module.exports = __webpack_public_path__ + "static/img/icon_case.e505049b.svg";